export const configGfsGroundDh = {
  "Controller": {
    "Name": "EXPO_NumericalDBExt",
    "data": "NCEP_MRF_GFS_0p25",
    "tile_size": 256
  },
  "Source": {
    "basetime": {
      "Type": "JSON",
      "url": "%numerical_db_gpv_url%/%data%/basetimes?use=map",
      "validtimes": 1,
      "time_to_target_for_comparison": 24,
      "retain": true,
      "cache_busting": "YYYYMMDDhhmm",
    },
    "validtime": {
      "Type": "JSON",
      "url": "%numerical_db_gpv_url%/%data%/valid_times?basetime=%basetime%&use=map",
      "retain": true,
      "cache": false,
      "cache_busting": true,
    },
    "region": {
      "Type": "JSON",
      "url": "%numerical_db_gpv_url%/%data%/area_info?use=map",
      "retain": true,
      "cache": true
    },
    "level": {
      "Type": "JSON",
      "url": "%numerical_db_gpv_url%/%data%/levels?use=map",
      "retain": true,
      "cache": true
    },
    "element": {
      "Type": "JSON",
      "url": "%numerical_db_gpv_url%/%data%/detailed_elements?use=map",
      "retain": true,
      "cache": true
    },
      "data": {
      "Type": "Binary",
      "url": "%numerical_db_gpv_url%/%data%/stride",
      "min_precision":1.0,
      "post_data": "{\"basetime\":\"%basetime%\",\"valid_time\":[\"%validtime%\"],\"elements\":[\"%element%\"],\"levels\" :[\"%level%\"],\"start_IGRID\" :%sx%,\"start_JGRID\":%sy%,\"end_IGRID\":%ex%,\"end_JGRID\":%ey%,\"stride_IGRID\":%dx%,\"stride_JGRID\":%dy%}",
      "alias": {
        "element": {
          "TMP": "AIRTMP",
          "RH": "RHUM"
        },
        "level": {
          "000": "0"
        }
      },
      "cache": true
    },
    "timelist": {
      "Type": "Derived",
      "retain": true,
      "cache": false,
      "cache_busting": true,
      "update_interval": 60,
    }
  }
}

export const configGfsGroundSpeedDirectionController = {
  "Controller": {
    "Name": "SpeedDirectionConverter",
    "UElement": "UWIND",
    "VElement": "VWIND"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "reference": configGfsGroundDh,
      "retain": true
    },
    "data": {
      "Type": "Derived",
      "reference": configGfsGroundDh
    }
  }
};

export const configGfsGroundUpConversionController = {
  "Controller": {
    "Name": "UpConversionFilter",
    "peak_filtering": true,
    "MaxScale": 4
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "reference": configGfsGroundDh,
      "retain": true
    },
    "level": {
      "Type": "JSON",
      "retain": true,
      "reference": configGfsGroundDh
    },
    "data": {
      "Type": "Derived",
      "reference": configGfsGroundDh
    }
  }
}

export const configGfsGroundIcingProbController = {
  "Controller": {
    "Name": "IcingProbability",
    "TMPElement": "TMP",
    "RHElement": "RH"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "reference": configGfsGroundDh,
      "retain": true
    },
    "data": {
      "Type": "Derived",
      "reference": configGfsGroundDh,
    }}
}

// 風 矢羽
export const configGfsGroundLayerWindArrow = {
  "Name": "GPVWindArrow",
  "Renderer": "WindArrow",
  "Attributes": {
    "style": {
      "default": {
        "min_blocksize": 40,
        "overlap_range": 80,
        "color": "rgb(156,97,44)"
      }
    }
  }
};

// 風 流線
export const configGfsGroundLayerStreamLine = {
  "Name" : "StreamLine",
  "Renderer" : "StreamLine",
  "Attributes" : {
    "data_scale" : 1.94384,
    // "min" : "1.0,     流線の生成を行う最低速度（デフォルト1.0）",
    // "scale" : "0.01,  UV値から緯度経度距離に変換する調整係数。大きくすると流線の点間隔が荒くなる。（デフォルト0.01）",
    // "times" : "80,     一本の流線を生成するシミュレーション回数＝流線が何本の折れ線で構成されるか（デフォルト80）",
    // "lines" : "10000,  生成する流線の数（デフォルト10000）",
    // "duration" : "10,  一本の流線のアニメーション時間（秒：デフォルト10）",
    // "separation" : "1, 一本の流線をいくつの部分に分割して表示するか（デフォルト1）（整数）",
    // "display" : "0.5,  一本の流線全体の中で、表示されている部分の比率（デフォルト0.5）",
    "min" : 1.0,
    "scale" : 0.01,
    "times" : 40,
    "lines" : 5000,
    "duration" : 3,
    "separation" : 1,
    "display" : 0.3,
    "style" : {
      "default" : {
        "palette_gradient": true,
        "palette_step": 0.1,
        "palette" : [
          {
            "value" : 0.1,
            "color" : "rgba(200,0,255,0.0)"
          },
          {
            "value" : 2.0,
            "color" : "rgba(0,0,255,0.7)"
          },
          {
            "value" : 10.0,
            "color" : "rgba(32,200,255,1.0)"
          },
          {
            "value" : 20.0,
            "color" : "rgba(48,255,255,1.0)"
          },
          {
            "value" : 40.0,
            "color" : "rgba(255,255,48,1.0)"
          },
          {
            "value" : 60.0,
            "color" : "rgba(255,0,0,1.0)"
          }
        ]
      }
    }
  }
}

// 風 等風速線 Contour
export const configGfsGroundLayerIsotach = {
  "Name" : "IsotachContour",
  "Renderer" : "Contour",
  "Attributes" : {
    "data_scale": 1.94384449,
    "data_offset": 0,
    "style" : {
      "default": {
        "contour": [
          {
            "base":20,
            "interval":20,
            "num": 4,
            "lineWidth": 1,
            "strokeStyle": "rgba(30, 144, 255, 0.7)",
            "textColor": "rgba(30, 144, 255, 1)",
            "fontSize": 14
          },
          {
            "base":100,
            "interval":20,
            "num": 3,
            "label_interval": 250,
            "lineWidth": 1,
            "strokeStyle": "rgba(78, 190, 78, 0.7)",
            "textColor": "rgba(78, 190, 78, 1)",
            "fontSize": 14
          },
          {
            "base":160,
            "interval":20,
            "num": 2,
            "label_interval": 125,
            "lineWidth": 1,
            "strokeStyle": "rgba(247, 200, 127, 0.7)",
            "textColor": "rgba(247, 200, 127, 1)",
            "fontSize": 14,
          }
        ]
      }
    }
  }
};

// 風 等風速線 Mesh
export const configGfsGroundLayerIsotachMesh = {
  "Name" : "IsotachFill",
  "Renderer" : "Mesh",
  "Attributes" : {
    "data_scale": 1.94384449,
    "data_offset": 0,
    "style" : {
      "default": {
        "fill_type" : "flat",
        "palette_gradient": false,
        "palette_step": 1,
        "palette" : [
          {
            "value" : 100.0,
            "color" : "rgba(144, 238, 144, 0.5)"
          },
          {
            "value" : 160.0,
            "color" : "rgba(250, 250, 210, 0.5)"
          },
          {
            "value" : 300.0,
            "color" : "rgba(250, 250, 210, 0.5)"
          }
        ]
      }
    }
  }
}

// 風 等風速線 Mesh Gradation
export const configGfsGroundLayerIsotachGradation = {
  "Name" : "IsotachFillGradation",
  "Renderer" : "Mesh",
  "Attributes" : {
    "style" : {
      "default": {
        "fill_type": "gradation",
        "palette_gradient": true,
        "palette_step": 1,
        "palette": [
          {
            "value": 0,
            "color": "rgba(98,113,183,0.5)"
          },
          {
            "value": 1,
            "color": "rgba(57,97,159,0.5)"
          },
          {
            "value": 3,
            "color": "rgba(74,148,169,0.5)"
          },
          {
            "value": 5,
            "color": "rgba(77,141,123,0.5)"
          },
          {
            "value": 7,
            "color": "rgba(83,165,83,0.5)"
          },
          {
            "value": 9,
            "color": "rgba(53,159,53,0.5)"
          },
          {
            "value": 11,
            "color": "rgba(167,157,81,0.5)"
          },
          {
            "value": 13,
            "color": "rgba(159,127,58,0.5)"
          },
          {
            "value": 15,
            "color": "rgba(161,108,92,0.5)"
          },
          {
            "value": 17,
            "color": "rgba(129,58,78,0.5)"
          },
          {
            "value": 19,
            "color": "rgba(175,80,136,0.5)"
          },
          {
            "value": 21,
            "color": "rgba(117,74,147,0.5)"
          },
          {
            "value": 24,
            "color": "rgba(109,97,163,0.5)"
          },
          {
            "value": 27,
            "color": "rgba(68,105,141,0.5)"
          },
          {
            "value": 29,
            "color": "rgba(92,144,152,0.5)"
          },
          {
            "value": 36,
            "color": "rgba(125,68,165,0.5)"
          },
          {
            "value": 46,
            "color": "rgba(231,215,215,0.5)"
          },
          {
            "value": 51,
            "color": "rgba(219,212,135,0.5)"
          },
          {
            "value": 77,
            "color": "rgba(205,202,112,0.5)"
          },
          {
            "value": 104,
            "color": "rgba(128,128,128,0.5)"
          }
        ]
      }
    }
  }
}

// 気温 等値線
export const configGfsGroundLayerIsotherm = {
  "Name": "GPVTempContour",
  "Renderer": "Contour",
  "Attributes": {
    "data_offset": -273.15,
    "style_selector": {
      "key": "level",
      "styles": [
        {
          "values": [
            "1000",
            "975",
            "950",
            "925",
            "900",
            "850"
          ],
          "style": "low"
        },
        {
          "values": [
            "800",
            "750",
            "700",
            "600",
            "500",
            "450",
            "400",
            "350",
            "300",
            "275",
            "250",
            "225",
            "200",
            "175",
            "150",
            "125",
            "100"
          ],
          "style": "high"
        }
      ]
    },
    "style": {
      "default": {
        "contour": [
          {
            "base": -198,
            "interval": 3,
            "num": 250,
            "strokeStyle": "rgba(128, 0, 0, 0.8)",
            "textColor": "rgba(128, 0, 0, 0.8)"
          }
        ]
      },
      "low": {
        "contour": [
          {
            "base": -198,
            "interval": 3,
            "num": 250,
            "strokeStyle": "rgba(128, 0, 0, 0.8)",
            "textColor": "rgba(128, 0, 0, 0.8)"
          }
        ]
      },
      "high": {
        "contour": [
          {
            "base": -198,
            "interval": 6,
            "num": 250,
            "strokeStyle": "rgba(128, 0, 0, 0.8)",
            "textColor": "rgba(128, 0, 0, 0.8)"
          }
        ]
      }
    }
  }
};

// 気温 色塗り Gradation
export const configGfsGroundLayerIsothermGradation = {
  "Name": "GPVTempFillGradation",
  "Renderer": "Mesh",
  "Attributes": {
    "data_offset": -273.15,
    "style": {
      "default": {
        "fill_type": "gradation",
        "palette_gradient": true,
        "palette_step": 1,
        "palette": [
          {
            "value": -96.0,
            "color": "rgba(  47,   6,  81, 0.5)"
          },
          {
            "value": -48.0,
            "color": "rgba(  73,  32, 107, 0.5)"
          },
          {
            "value": -36.0,
            "color": "rgba(   0,  32, 128, 0.5)"
          },
          {
            "value": -24.0,
            "color": "rgba(   0,  65, 255, 0.5)"
          },
          {
            "value": -12.0,
            "color": "rgba(   0, 150, 255, 0.5)"
          },
          {
            "value": -6.0,
            "color": "rgba( 185, 235, 255, 0.5)"
          },
          {
            "value": 0.0,
            "color": "rgba( 233, 255, 237, 0.5)"
          },
          {
            "value": 6.0,
            "color": "rgba(   0, 255, 184, 0.5)"
          },
          {
            "value": 12.0,
            "color": "rgba(   1, 249,  15, 0.5)"
          },
          {
            "value": 18.0,
            "color": "rgba( 255, 255, 150, 0.5)"
          },
          {
            "value": 24.0,
            "color": "rgba( 250, 245,   0, 0.5)"
          },
          {
            "value": 30.0,
            "color": "rgba( 255, 153,   0, 0.5)"
          },
          {
            "value": 36.0,
            "color": "rgba( 255,  40,   0, 0.5)"
          },
          {
            "value": 42.0,
            "color": "rgba( 180,   0, 104, 0.5)"
          },
          {
            "value": 48.0,
            "color": "rgba( 168,   0, 255, 0.5)"
          }
        ]
      }
    }
  }
};

// 気温 グリッド値
export const configGfsGroundLayerIsothermGrid = {
  "Name": "GPVTempGridValue",
  "Renderer": "GridValueExt",
  "Attributes": {
    "data_offset": -273.15,
    "style": {
      "default": {
        "min_blocksize": 40,
        "overlap_range": 80,
        "fractional_digits": 0,
        "color": "rgba(0, 0, 0, 1.0)",
        "offset_x": 0,
        "offset_y": 6
      },
      "dark": {
        "min_blocksize": 40,
        "overlap_range": 80,
        "fractional_digits": 0,
        "color": "rgba(255, 255, 255, 1.0)",
        "offset_x": 0,
        "offset_y": 6
      }
    }
  }
};

// 着氷の指標
export const configGfsGroundLayerIcingProb = {
  "Name": "IcingProbavility",
  "Renderer": "GridIcon",
  "Attributes": {
    "style": {
      "default": {
        "min_blocksize": 20,
        "settings": [
          {
            "eq": 1,
            "type": "text",
            "text": "✱",
            "text_color": "#000000"
          }
        ]
      },
      "dark": {
        "min_blocksize": 20,
        "settings": [
          {
            "eq": 1,
            "type": "text",
            "text": "＊",
            "text_color": "#c4c2c2"
          }
        ]
      }
    }
  }
};

// 前1時間降水量 Mesh
export const configGfsGroundLayerPrecipitation1hMesh = {
  "Name": "GPVPrcrin1hFill",
  "Renderer": "Mesh",
  "Attributes": {
    "data_scale": 10,
    "style": {
      "default": {
        "fill_type": "gradation",
        "palette_gradient": true,
        "palette_step": 1,
        "palette": [
          {
            "value": 1,
            "color": "rgba(178, 203, 228, 0.5)"
          },
          {
            "value": 5,
            "color": "rgba(0, 255, 255, 0.5)"
          },
          {
            "value": 10,
            "color": "rgba(0, 144, 255, 0.5)"
          },
          {
            "value": 20,
            "color": "rgba(0, 0, 255, 0.5)"
          },
          {
            "value": 40,
            "color": "rgba(6, 207, 34, 0.5)"
          },
          {
            "value": 80,
            "color": "rgba(0, 255, 0, 0.5)"
          },
          {
            "value": 120,
            "color": "rgba(135, 255, 6, 0.5)"
          },
          {
            "value": 160,
            "color": "rgba(255, 255, 0, 0.5)"
          },
          {
            "value": 240,
            "color": "rgba(255, 191, 0, 0.5)"
          },
          {
            "value": 320,
            "color": "rgba(255, 165, 0, 0.5)"
          },
          {
            "value": 400,
            "color": "rgba(255, 140, 0, 0.5)"
          },
          {
            "value": 480,
            "color": "rgba(255, 21, 6, 0.5)"
          },
          {
            "value": 560,
            "color": "rgba(255, 0, 0, 0.5)"
          },
          {
            "value": 640,
            "color": "rgba(244, 0, 161, 0.5)"
          },
          {
            "value": 800,
            "color": "rgba(255, 0, 255, 0.5)"
          },
        ]
      }
    }
  }
};

// 前1時間降水量 等値線
export const configGfsGroundLayerPrecipitation1hContour = {
  "Name": "GPVPrcrin1hContour",
  "Renderer": "Contour",
  "Attributes": {
    "style": {
      "default": {
        "contour": [
          {
            "base": 0.1,
            "interval": 0.4,
            "fractional_digits": 1,
            "num": 2,
            "unit_label": "㎜",
            "label_interval": 256,
            "max_label_num": 3,
            "strokeStyle": "rgba(69,84,179,0.8)",
            "textColor": "rgba(69,84,179,0.9)"
          },
          {
            "base": 1.0,
            "interval": 1,
            "num": 2,
            "unit_label": "㎜",
            "label_interval": 256,
            "max_label_num": 3,
            "strokeStyle": "rgba(69,84,179,0.8)",
            "textColor": "rgba(69,84,179,0.9)"
          },
          {
            "base": 4.0,
            "interval": 4.0,
            "num": 2,
            "unit_label": "㎜",
            "label_interval": 256,
            "max_label_num": 3,
            "strokeStyle": "rgba(69,84,179,0.8)",
            "textColor": "rgba(69,84,179,0.9)"
          },
          {
            "base": 16.0,
            "interval": 16.0,
            "num": 2,
            "unit_label": "㎜",
            "label_interval": 256,
            "max_label_num": 3,
            "strokeStyle": "rgba(69,84,179,0.8)",
            "textColor": "rgba(69,84,179,0.9)"
          },
          {
            "base": 64.0,
            "interval": 64.0,
            "num": 2,
            "unit_label": "㎜",
            "label_interval": 256,
            "max_label_num": 3,
            "strokeStyle": "rgba(69,84,179,0.8)",
            "textColor": "rgba(69,84,179,0.9)"
          }
        ]
      }
    }
  }
};

// 前1時間降水量 グリッド値
export const configGfsGroundLayerPrecipitation1hGrid = {
  "Name": "CommonGridValue",
  "Renderer": "GridValueExt",
  "Attributes": {
    "_data_scale": 10,
    "_data_offset": -273.15,
    "cross_fade": 0.7,
    "style": {
      "default": {
        "min_blocksize": 40,
        "overlap_range": 60,
        "fractional_digits": 1,
        "color": "rgba(0, 0, 0, 1.0)",
        "offset_x": 0,
        "offset_y": 6
      },
      "dark": {
        "min_blocksize": 40,
        "overlap_range": 60,
        "fractional_digits": 1,
        "color": "rgba(255, 255, 255, 1.0)",
        "offset_x": 0,
        "offset_y": 6
      }
    }
  }
}

// 相対湿度（コンター）
export const configGfsGroundLayerRelativeHumidityContour = {
  "Name": "RelativeHumidityContour",
  "Renderer": "Contour",
  "Attributes": {
    "_data_offset": 0,
    "_data_scale": 1,
    "style": {
      "default": {
        "contour": [
          {
            "base": 0,
            "interval": 5,
            "num": 21,
            "unit_label": "%",
            "label_interval" : 256,
            "max_label_num" : 3,
            "strokeStyle": "rgba(0, 0, 255, 0.5)",
            "textColor": "rgb(0, 0, 255)"
          }
        ]
      }
    }
  }
};

// 相対湿度（グラデーション）
export const configGfsGroundLayerRelativeHumidityGradation = {
  "Name": "RelativeHumidityFill",
  "Renderer": "Mesh",
  "Attributes": {
    "style": {
      "default": {
        "fill_type": "gradation",
        "palette_gradient": true,
        "palette_step": 1,
        "palette": [
          {
            "value": 70,
            "color": "rgba(184, 241, 241, 0.5)"
          },
          {
            "value": 75,
            "color": "rgba(149, 234, 234, 0.5)"
          },
          {
            "value": 80,
            "color": "rgba(78, 220, 220, 0.5)"
          },
          {
            "value": 85,
            "color": "rgba(35, 177, 177, 0.5)"
          },
          {
            "value": 90,
            "color": "rgba(29, 141, 141, 0.5)"
          },
          {
            "value": 95,
            "color": "rgba(21, 106, 106, 0.5)"
          },
          {
            "value": 100,
            "color": "rgba(14, 71, 71, 0.5)"
          }
        ]
      }
    }
  }
};

// 海面更正気圧 等値線
export const configGfsGroundLayerPressuremslContour = {
  "Name": "GPVPressuremslContour",
  "Renderer": "Contour",
  "Attributes": {
    "data_scale": 0.01,
    "style": {
      "default": {
        "_contour_label_priority": "descend",
        "contour_label_priority": "ascend",
        "contour": [
          {
            "base": 800,
            "interval": 20,
            "num": 10,
            "unit_label": "hPa",
            "label_interval": 1,
            "max_label_num": 1,
            "strokeStyle": "rgba(0,9,138,1.0)",
            "lineWidth": 3,
            "_lineDash": [2, 3],
            "fontSize": 14,
            "textEdgeColor": "white",
            "_textColor": "rgba(20,20,80,1.0)",
            "textColor": "rgba(255,20,80,1.0)"
          },
          {
            "base": 804,
            "interval": 20,
            "num": 10,
            "unit_label": "hPa",
            "label_interval": 1,
            "max_label_num": 1,
            "strokeStyle": "rgba(0,9,138,1.0)",
            "lineWidth": 1,
            "_lineDash": [2, 3],
            "textEdgeColor": "white",
            "textColor": "rgba(20,20,80,1.0)"
          },
          {
            "base": 808,
            "interval": 20,
            "num": 10,
            "unit_label": "hPa",
            "label_interval": 1,
            "max_label_num": 1,
            "strokeStyle": "rgba(0,9,138,1.0)",
            "lineWidth": 1,
            "_lineDash": [2, 3],
            "textEdgeColor": "white",
            "textColor": "rgba(20,20,80,1.0)"
          },
          {
            "base": 812,
            "interval": 20,
            "num": 10,
            "unit_label": "hPa",
            "label_interval": 1,
            "max_label_num": 1,
            "strokeStyle": "rgba(0,9,138,1.0)",
            "lineWidth": 1,
            "_lineDash": [2, 3, 10, 3],
            "textEdgeColor": "white",
            "textColor": "rgba(20,20,80,1.0)"
          },
          {
            "base": 816,
            "interval": 20,
            "num": 10,
            "unit_label": "hPa",
            "label_interval": 1,
            "max_label_num": 1,
            "strokeStyle": "rgba(0,9,138,1.0)",
            "lineWidth": 1,
            "_lineDash": [2, 3, 10, 3],
            "textEdgeColor": "white",
            "textColor": "rgba(20,20,80,1.0)"
          },
          {
            "base": 1000,
            "interval": 20,
            "num": 10,
            "unit_label": "hPa",
            "label_interval": 150,
            "max_label_num": 2,
            "strokeStyle": "rgba(0,9,138,1.0)",
            "lineWidth": 3,
            "_lineDash": [2, 3],
            "fontSize": 14,
            "textEdgeColor": "white",
            "_textColor": "rgba(20,20,80,1.0)",
            "textColor": "rgba(20,20,255,1.0)"
          },
          {
            "base": 1004,
            "interval": 20,
            "num": 10,
            "unit_label": "hPa",
            "label_interval": 150,
            "max_label_num": 1,
            "strokeStyle": "rgba(0,9,138,1.0)",
            "lineWidth": 1,
            "_lineDash": [2, 3],
            "textEdgeColor": "white",
            "textColor": "rgba(20,20,80,1.0)"
          },
          {
            "base": 1008,
            "interval": 20,
            "num": 10,
            "unit_label": "hPa",
            "label_interval": 150,
            "max_label_num": 1,
            "strokeStyle": "rgba(0,9,138,1.0)",
            "lineWidth": 1,
            "_lineDash": [2, 3],
            "textEdgeColor": "white",
            "textColor": "rgba(20,20,80,1.0)"
          },
          {
            "base": 1012,
            "interval": 20,
            "num": 10,
            "unit_label": "hPa",
            "label_interval": 150,
            "max_label_num": 1,
            "strokeStyle": "rgba(0,9,138,1.0)",
            "lineWidth": 1,
            "_lineDash": [2, 3, 10, 3],
            "textEdgeColor": "white",
            "textColor": "rgba(20,20,80,1.0)"
          },
          {
            "base": 1016,
            "interval": 20,
            "num": 10,
            "unit_label": "hPa",
            "label_interval": 100,
            "max_label_num": 1,
            "strokeStyle": "rgba(0,9,138,1.0)",
            "lineWidth": 1,
            "_lineDash": [2, 3, 10, 3],
            "textEdgeColor": "white",
            "textColor": "rgba(20,20,80,1.0)"
          }
        ]
      },
      "dark": {
        "_contour_label_priority": "descend",
        "contour_label_priority": "ascend",
        "contour": [
          {
            "base": 800,
            "interval": 20,
            "num": 10,
            "unit_label": "hPa",
            "label_interval": 1,
            "max_label_num": 1,
            "strokeStyle": "rgba(158,182,255,1.0)",
            "lineWidth": 3,
            "_lineDash": [2, 3],
            "fontSize": 14,
            "textEdgeColor": "white",
            "_textColor": "rgba(20,20,80,1.0)",
            "textColor": "rgba(255,20,80,1.0)"
          },
          {
            "base": 804,
            "interval": 20,
            "num": 10,
            "unit_label": "hPa",
            "label_interval": 1,
            "max_label_num": 1,
            "strokeStyle": "rgba(158,182,255,1.0)",
            "lineWidth": 1,
            "_lineDash": [2, 3],
            "textEdgeColor": "white",
            "textColor": "rgba(20,20,80,1.0)"
          },
          {
            "base": 808,
            "interval": 20,
            "num": 10,
            "unit_label": "hPa",
            "label_interval": 1,
            "max_label_num": 1,
            "strokeStyle": "rgba(158,182,255,1.0)",
            "lineWidth": 1,
            "_lineDash": [2, 3],
            "textEdgeColor": "white",
            "textColor": "rgba(20,20,80,1.0)"
          },
          {
            "base": 812,
            "interval": 20,
            "num": 10,
            "unit_label": "hPa",
            "label_interval": 1,
            "max_label_num": 1,
            "strokeStyle": "rgba(158,182,255,1.0)",
            "lineWidth": 1,
            "_lineDash": [2, 3, 10, 3],
            "textEdgeColor": "white",
            "textColor": "rgba(20,20,80,1.0)"
          },
          {
            "base": 816,
            "interval": 20,
            "num": 10,
            "unit_label": "hPa",
            "label_interval": 1,
            "max_label_num": 1,
            "strokeStyle": "rgba(158,182,255,1.0)",
            "lineWidth": 1,
            "_lineDash": [2, 3, 10, 3],
            "textEdgeColor": "white",
            "textColor": "rgba(20,20,80,1.0)"
          },
          {
            "base": 1000,
            "interval": 20,
            "num": 10,
            "unit_label": "hPa",
            "label_interval": 150,
            "max_label_num": 2,
            "strokeStyle": "rgba(158,182,255,1.0)",
            "lineWidth": 3,
            "_lineDash": [2, 3],
            "fontSize": 14,
            "textEdgeColor": "white",
            "_textColor": "rgba(20,20,80,1.0)",
            "textColor": "rgba(20,20,255,1.0)"
          },
          {
            "base": 1004,
            "interval": 20,
            "num": 10,
            "unit_label": "hPa",
            "label_interval": 150,
            "max_label_num": 1,
            "strokeStyle": "rgba(158,182,255,1.0)",
            "lineWidth": 1,
            "_lineDash": [2, 3],
            "textEdgeColor": "white",
            "textColor": "rgba(20,20,80,1.0)"
          },
          {
            "base": 1008,
            "interval": 20,
            "num": 10,
            "unit_label": "hPa",
            "label_interval": 150,
            "max_label_num": 1,
            "strokeStyle": "rgba(158,182,255,1.0)",
            "lineWidth": 1,
            "_lineDash": [2, 3],
            "textEdgeColor": "white",
            "textColor": "rgba(20,20,80,1.0)"
          },
          {
            "base": 1012,
            "interval": 20,
            "num": 10,
            "unit_label": "hPa",
            "label_interval": 150,
            "max_label_num": 1,
            "strokeStyle": "rgba(158,182,255,1.0)",
            "lineWidth": 1,
            "_lineDash": [2, 3, 10, 3],
            "textEdgeColor": "white",
            "textColor": "rgba(20,20,80,1.0)"
          },
          {
            "base": 1016,
            "interval": 20,
            "num": 10,
            "unit_label": "hPa",
            "label_interval": 100,
            "max_label_num": 1,
            "strokeStyle": "rgba(158,182,255,1.0)",
            "lineWidth": 1,
            "_lineDash": [2, 3, 10, 3],
            "textEdgeColor": "white",
            "textColor": "rgba(20,20,80,1.0)"
          }
        ]
      }
    }
  }
}

// 海面更正気圧 高/低マーク
export const configGfsGroundLayerPressuremslHiLo = {
  "Name": "HiLo",
  "Renderer": "HiLo",
  "Attributes": {
    "data_offset": 0,
    "data_scale": 0.01,
    "style": {
      "default": {
        "fractional_digits" : 0,
        "unit_label": "hPa",
        "point_size": 8,
        "mark_font_size": 14,
        "text_font_size": 12,
        "hi_mark":"H",
        "lo_mark":"L",
        "hi_point_color": "rgba(0, 0, 250, 0.8)",
        "hi_point_edge_color": "rgba(255, 255, 255, 0.8)",
        "lo_point_color": "rgba(250, 0, 0, 0.8)",
        "lo_point_edge_color": "rgba(255, 255, 255, 0.8)",
        "_hi_text_color": "rgba(0, 0, 5, 0.8)",
        "_hi_text_edge_color": "rgba(255, 255, 255, 0.8)",
        "hi_text_color": "rgba(20,20,80,1.0)",
        "hi_text_edge_color": "white",
        "_lo_text_color": "rgba(50, 0, 0, 0.8)",
        "_lo_text_edge_color": "rgba(255, 255, 255, 0.8)",
        "lo_text_color": "rgba(20,20,80,1.0)",
        "lo_text_edge_color": "white",
        "text_offset_x": 0,
        "text_offset_y": 16,
        "hi_mark_color": "rgba(0, 0, 250, 0.8)",
        "hi_mark_edge_color": "rgba(255, 255, 255, 0.8)",
        "lo_mark_color": "rgba(250, 0, 0, 0.8)",
        "lo_mark_edge_color": "rgba(255, 255, 255, 0.8)",
        "mark_offset_x": 0,
        "mark_offset_y": -8
      }
    }
  }
}

// 視程 グラデーション
export const configGfsGroundLayerVisibilityGradation = {
  "Name": "GPVVisGradation",
  "Renderer": "Mesh",
  "Attributes": {
    "style": {
      "default": {
        "fill_type": "gradation",
        "palette_gradient": true,
        "palette_step": 100,
        "palette": [
          {
            "value": 0,
            "color": "rgba(163,89,163,0.5)"
          },
          {
            "value": 1000,
            "color": "rgba(167,86,86,0.5)"
          },
          {
            "value": 5000,
            "color": "rgba(89,101,163,0.5)"
          },
          {
            "value": 10000,
            "color": "rgba(60,188,73,0.5)"
          },
          {
            "value": 15000,
            "color": "rgba(83,167,75,0.5)"
          },
          {
            "value": 20000,
            "color": "rgba(121,121,121,0.0)"
          }
        ]
      }
    }
  }
}

// 視程 等値線
export const configGfsGroundLayerVisibilityContour = {
  "Name": "GPVVisContour",
  "Renderer": "Contour",
  "Attributes": {
    "_data_scale": 0.001,
    "style": {
      "default": {
        "contour": [
          {
            "base": 500,
            "interval": 500,
            "fractional_digits": 1,
            "num": 1,
            "unit_label": "m",
            "label_interval": 256,
            "max_label_num": 3,
            "strokeStyle": "rgba(255,0,221,1.0)",
            "textColor": "rgba(20,20,80,0.9)"
          },
          {
            "base": 1000,
            "interval": 4000,
            "num": 2,
            "unit_label": "m",
            "label_interval": 256,
            "max_label_num": 3,
            "strokeStyle": "rgba(255,0,221,1.0)",
            "textColor": "rgba(20,20,80,0.9)"
          },
          {
            "base": 10000,
            "interval": 10000,
            "num": 2,
            "unit_label": "m",
            "label_interval": 256,
            "max_label_num": 3,
            "strokeStyle": "rgba(255,0,221,1.0)",
            "textColor": "rgba(20,20,80,0.9)"
          }
        ]
      }
    }
  }
}

// 下層雲量 グラデーション
export const configGfsGroundLayerLowCloudCoverGradation = {
  "Name": "CloudFillStyle",
  "Renderer": "Mesh",
  "Attributes": {
    "style": {
      "default": {
        "fill_type": "gradation",
        "palette_gradient": true,
        "palette_step": 5,
        "palette": [
          {
            "value": 0,
            "color": "rgba(156,142,87,0.5)"
          },
          {
            "value": 10,
            "color": "rgba(143,131,87,0.5)"
          },
          {
            "value": 30,
            "color": "rgba(129,129,129,0.5)"
          },
          {
            "value": 60,
            "color": "rgba(137,159,182,0.5)"
          },
          {
            "value": 100,
            "color": "rgba(187,187,187,0.5)"
          }
        ]
      },
    }
  }
}

// 下層雲量 等値線
export const configGfsGroundLayerLowCloudCoverContour = {
  "Name": "CommonContour",
  "Renderer": "Contour",
  "Attributes": {
    "_data_offset": 0,
    "_data_scale": 1,
    "style": {
      "default": {
        "contour": [
          {
            "base": 0,
            "interval": 20,
            "fractional_digits": 0,
            "num": 10,
            "unit_label": "%",
            "label_interval": 256,
            "max_label_num": 3,
            "strokeStyle": "rgba(51,51,51,1.0)",
            "textColor": "rgba(20,20,80,0.9)"
          }
        ]
      },
      "dark": {
        "contour": [
          {
            "base": 0,
            "interval": 20,
            "fractional_digits": 0,
            "num": 10,
            "unit_label": "%",
            "label_interval": 256,
            "max_label_num": 3,
            "strokeStyle": "rgba(222,222,222,1.0)",
            "textColor": "rgba(20,20,80,0.9)"
          }
        ]
      }
    }
  }
}

// 中層雲量 グラデーション
export const configGfsGroundLayerMediumCloudCoverGradation = {
  "Name": "CloudFillStyle",
  "Renderer": "Mesh",
  "Attributes": {
    "style": {
      "default": {
        "fill_type": "gradation",
        "palette_gradient": true,
        "palette_step": 5,
        "palette": [
          {
            "value": 0,
            "color": "rgba(156,142,87,0.5)"
          },
          {
            "value": 10,
            "color": "rgba(143,131,87,0.5)"
          },
          {
            "value": 30,
            "color": "rgba(157,192,157,0.5)"
          },
          {
            "value": 50,
            "color": "rgba(145,171,145,0.5)"
          },
          {
            "value": 100,
            "color": "rgba(187,187,187,0.5)"
          }
        ]
      },
    }
  }
}

// 中層雲量 等値線
export const configGfsGroundLayerMediumCloudCoverContour = {
  "Name": "CommonContour",
  "Renderer": "Contour",
  "Attributes": {
    "_data_offset": 0,
    "_data_scale": 1,
    "style": {
      "default": {
        "contour": [
          {
            "base": 0,
            "interval": 20,
            "fractional_digits": 0,
            "num": 10,
            "unit_label": "%",
            "label_interval": 256,
            "max_label_num": 3,
            "strokeStyle": "rgba(51,51,51,1.0)",
            "textColor": "rgba(20,20,80,0.9)"
          }
        ]
      },
      "dark": {
        "contour": [
          {
            "base": 0,
            "interval": 20,
            "fractional_digits": 0,
            "num": 10,
            "unit_label": "%",
            "label_interval": 256,
            "max_label_num": 3,
            "strokeStyle": "rgba(222,222,222,1.0)",
            "textColor": "rgba(20,20,80,0.9)"
          }
        ]
      }
    }
  }
}

// 上層雲量 グラデーション
export const configGfsGroundLayerHighCloudCoverGradation = {
  "Name": "CloudFillStyle",
  "Renderer": "Mesh",
  "Attributes": {
    "style": {
      "default": {
        "fill_type": "gradation",
        "palette_gradient": true,
        "palette_step": 5,
        "palette": [
          {
            "value": 0,
            "color": "rgba(156,142,87,0.5)"
          },
          {
            "value": 10,
            "color": "rgba(143,131,87,0.5)"
          },
          {
            "value": 30,
            "color": "rgba(125,157,157,0.5)"
          },
          {
            "value": 50,
            "color": "rgba(141,169,169,0.5)"
          },
          {
            "value": 100,
            "color": "rgba(187,187,187,0.5)"
          }
        ]
      }
    }
  }
}

// 上層雲量 等値線
export const configGfsGroundLayerHighCloudCoverContour = {
  "Name": "CommonContour",
  "Renderer": "Contour",
  "Attributes": {
    "_data_offset": 0,
    "_data_scale": 1,
    "style": {
      "default": {
        "contour": [
          {
            "base": 0,
            "interval": 20,
            "fractional_digits": 0,
            "num": 10,
            "unit_label": "%",
            "label_interval": 256,
            "max_label_num": 3,
            "strokeStyle": "rgba(51,51,51,1.0)",
            "textColor": "rgba(20,20,80,0.9)"
          }
        ]
      },
      "dark": {
        "contour": [
          {
            "base": 0,
            "interval": 20,
            "fractional_digits": 0,
            "num": 10,
            "unit_label": "%",
            "label_interval": 256,
            "max_label_num": 3,
            "strokeStyle": "rgba(222,222,222,1.0)",
            "textColor": "rgba(20,20,80,0.9)"
          }
        ]
      }
    }
  }
}